import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Contact from './pages/Contact'
import Privacy_policy from './pages/Privacy-policy'
import Terms from './pages/Terms'
import ScrollToTop from './components/ScrollToTop'
import PageSEO from './components/PageSEO'
import Vacancies from './pages/Vacancies'
import Projects from './pages/Projects'
import VacanciesView from './pages/Vacancies_view'
import ProjectsView from './pages/Projects_view'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white w-full overflow-x-hidden">
        <ScrollToTop />
        <PageSEO />
        <Header />
        <main className="w-full min-w-0 overflow-x-hidden">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/vacancy" element={<Vacancies/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/privacy-policy" element={<Privacy_policy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/vacancy/:id" element={<VacanciesView />} />
            <Route path="/project/:id" element={<ProjectsView />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
